import React, {cloneElement, FC, useState} from "react";
import {
    Placement,
    offset,
    flip,
    shift,
    autoUpdate,
    useFloating,
    useInteractions,
    useHover,
    useFocus,
    useRole,
    useDismiss
} from "@floating-ui/react-dom-interactions";
import {createPortal} from "react-dom";

interface ToolTipProps {
    children: JSX.Element,
    text: string,
    placement?: Placement,
    className?: string
}

const ToolTip: FC<ToolTipProps> = ({children, text, className, placement}) => {
    const [open, setOpen] = useState(false);
    const {x, y, reference, floating, strategy, context} = useFloating({
        placement,
        open,
        onOpenChange: setOpen,
        middleware: [offset(5), flip(), shift({padding: 8})],
        whileElementsMounted: autoUpdate
    });
    const {getReferenceProps, getFloatingProps} = useInteractions([
        useHover(context),
        useFocus(context),
        useRole(context, {role: "tooltip"}),
        useDismiss(context)
    ]);

    return (
        <div className={className}>
            {children && cloneElement(
                children,
                getReferenceProps({ref: reference, ...children.props})
            )}
            {open && createPortal(
                <div
                    {...getFloatingProps({
                        ref: floating,
                        className: "z-50 bg-black text-white text-sm pl-2 pr-2 pb-1 pt-1 rounded-md",
                        style: {
                            position: strategy,
                            top: y ?? 0,
                            left: x ?? 0
                        }
                    })}
                    dangerouslySetInnerHTML={{__html: text}}
                />,
                document.body
            )}
        </div>
    );
};

export default ToolTip;
